import grass from './assets/grass.jpeg'
import shrub from './assets/shrub.png'
export const TILE_IMAGES = {
  '#': grass,
  '.': grass,
  'S': shrub,
}

export const TILE_SIZE = 48

const style = {
  tile_images: {
    width: '3rem', 
    height: '3rem', 
    objectFit: 'cover', 
    marginRight: '1px', 
    marginLeft: '1px', 
    marginTop: '1px', 
    marginBottom: '1px'
  }
}

// initial player position 
export const PLAYER_START = { r: 1, c: 1 }

// "stops" (row, col) mapped to their content IDs
export const STOPS = [
  { r: 4, c: 0, id: 'about', label: 'About' },
  { r: 1, c: 5, id: 'interests', label: 'Interests' },
  { r: 8, c: 8, id: 'research',  label: 'Research'  },
  { r: 5, c: 3, id: 'background',   label: 'Background'   },
  { r: 6, c: 7, id: 'work', label: 'Work'},
  { r: 3, c: 4, id: 'projects', label: 'Projects'}, 
]

export const PATH = {
  '#': { walkable: true, type: 'grass',
  'S': { walkable: true, type: 'stop'}
  }
}

export const MAP_VIS = []
for (let r = 0; r < 10; r++) {
  const currRow = []
  for (let c = 0; c < 15; c++) {
    currRow.push(TILE_IMAGES['#'] ? <img key={`${r}-${c}`} src={TILE_IMAGES['#']} alt="" title={`${STOPS.find(s => s.r === r && s.c === c)?.label || ''}`}style={style.tile_images} /> : '#')
  }
  MAP_VIS.push(currRow) 
}

export const MAP_GRID = []
for (let r = 0; r < 10; r++){
  const currRow = []
  for (let c = 0; c < 15; c++) {
    const isStop = STOPS.some(s => s.r === r && s.c === c)
    
    currRow.push(isStop ? 'S' : '.')
  }
  MAP_GRID.push(currRow)
}